import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_AURORA } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/hope.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/hope-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/hope-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/hope-extreme.circles.json' with { type: 'json' };

export const HOPE_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'hope',
  baseTitle: "Dreams pt. II",
  description: "Lost Sky's melodic-trap with Sara Skinner's vocal hook. A calm entry-tier cube glide.",
  difficulty: 1,
  palette: PALETTE_AURORA,
  attribution: "\"Dreams pt. II (feat. Sara Skinner)\" by Lost Sky [NCS Release] - https://ncs.io/Dreams2",
  mapper: "Jonny_NOS",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    hard: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    extreme: { bpm: 145, offsetMs: 0, totalBeats: 148 },
  },
});
